import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import {
  type GetPendingOrderApprovalsResponse,
  OrderApprovalsClient,
} from "@lib/ShiOneClient";
import { EcommerceQueryKeys } from "@features/ecommerce/hooks/ecommerceQueryKeys";

export default function useGetPendingOrderApprovals(take = 5) {
  const api = useApi(OrderApprovalsClient);

  const fetchPending = async (): Promise<GetPendingOrderApprovalsResponse> => {
    return await api.getPendingOrderApprovals(take);
  };

  return useQuery({
    queryKey: [EcommerceQueryKeys.PendingOrders, take],
    queryFn: fetchPending,
  });
}
